<template>
  <div class="content__item-form-type content__item-form-type--textarea">
    <div
      class="content__item-form-group content__item-form-group--textarea form-group"
      :class="{
        'form-group--error': showValidationErrors && !state.isValid,
        'form-group--has-value': state.value && state.value !== '',
        'form-group--is-disabled': model.state?.readonly,
        'form-group--is-focus': isFocus,
        'form-group--valid': !!state.isValid
      }"
    >
      <label class="content__item-form-label content__item-form-label--textarea">{{ model.state?.label }}</label>
      <textarea
        :id="`${model.state?.id}`"
        v-model="state.value"
        :aria-label="model.state.label"
        class="content__item-form-textarea form-control"
        :placeholder="model.state?.placeholder"
        :name="`form[${model.state?.id}]`"
        :type="model.state?.inputHtmlType"
        :rows="model.state?.textareaRows"
        :disabled="model.state?.readonly || false"
        :autocomplete="model.state.disableAutocomplete ? 'off' : 'on'"
        :maxlength="model.state?.validation?.maxChars || undefined"
        @focus="onFocus"
        @blur="onBlur"
      >
      </textarea>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, ref } from 'vue';
import type { FormElementTextareaModel } from '@/src/components/addons/registration/Models/FormElementTextareaModel';

export default defineComponent({
  name: 'FormElementTextarea',
  props: {
    model: {
      type: Object as PropType<FormElementTextareaModel>,
      required: true
    },

    showValidationErrors: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const model = props.model;
    const state = model.state;
    const isFocus = ref(false);
    const isReadOnly = ref(false);

    const onBlur = () => {
      isFocus.value = false;
    };
    const onFocus = () => {
      isFocus.value = true;
    };

    return {
      state,
      onBlur,
      onFocus,
      isFocus,
      isReadOnly
    };
  }
});
</script>

<style lang="scss">
.content__item-form-textarea {
  height: auto !important;
}
</style>
